@if (workflowPublishedVersion) {
  <form class="w-100 h-100">
    <table class="w-100 h-100">
      <thead style="background: #e1e1e1;" class="font-weight-400 fs-14">
        @for (column of workflowTableData?.columns[0].cells; track column) {
<th style="font-weight: 500;
            font-size: 15px;">
            {{ workflowTranslations[selectedLang][column.templateOptions?.label] }}
          </th>
        }
      </thead>
      <tbody style="border-width:none ;">
        @for (row of workflowTableData?.rows; track row; let rowIndex = $index) {
          <tr style="border: solid 1px;">
            @for (column of row.cells; track column; let columnIndex = $index) {
              <td>
                @if (tableData?.[column.key] && !column.templateOptions?.options) {
                  <div class="ps-1" [ngStyle]="{'min-width': column.type == 'datepicker' ? '125px' : ''}">
                    <label for="">{{tableData?.[column.key]}}</label>
                    @if (column.type == 'number' && column.templateOptions?.['unit']) {
                      <label class="ms-2">{{column.templateOptions?.['unit']}}</label>
                    }
                  </div>
                }
                @if (column.type == 'multicheckbox') {
                  <div>
                    @for (option of column.templateOptions?.options; track option) {
                      <div>
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [id]="'input-'+option.value"
                          [value]="option.value"
                          disabled
                          [checked]="tableData?.[column.key] ? tableData?.[column.key].includes(option.value) : false"
                          />
                        @if (workflowTranslations[selectedLang]?.[option.label]) {
                          <label class="form-check-label" [for]="'input-'+option.value">
                            {{ workflowTranslations[selectedLang]?.[option.label] }}
                          </label>
                        }
                      </div>
                    }
                  </div>
                }
                @if (column.type == 'radio') {
                  <div>
                    @for (option of column.templateOptions?.options; track option) {
                      <div>
                        <input
                          type="radio"
                          class="form-check-input"
                          [id]="'input-'+option.value"
                          [value]="option.value"
                          disabled
                          [checked]="tableData?.[column.key] ? tableData?.[column.key].includes(option.value) : false"
                          />
                        @if (workflowTranslations[selectedLang]?.[option.label]) {
                          <label class="form-check-label" [for]="'input-'+option.value">
                            {{ workflowTranslations[selectedLang]?.[option.label] }}
                          </label>
                        }
                      </div>
                    }
                  </div>
                }
                <!-- Display label value for label type cells -->
                @if (!tableData?.[column.key] && column.type == 'label') {
                  <div>
                    <label for="">{{workflowTranslations[selectedLang]?.[column.templateOptions.label]}}</label>
                  </div>
                }
                <!-- Display N/A for empty cells (except labels, checkboxes, and radios) -->
                @if (!tableData?.[column.key] && column.type !== 'label' && column.type !== 'multicheckbox' && column.type !== 'radio') {
                  <div>
                    <label for="" style="color: #A1A1A1;">N/A</label>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </form>
}